import { render, staticRenderFns } from "./StatusEnvioMds.vue?vue&type=template&id=3d51fcd8"
import script from "./StatusEnvioMds.vue?vue&type=script&lang=js"
export * from "./StatusEnvioMds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports